import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICommand } from '../telemetry/models/capability-model-data';
import { CommandSelectedEvent } from './command-selected-event';

@Component({
    selector: 'app-commands-properties',
    templateUrl: './commands-properties.component.html',
    styleUrls: ['./commands-properties.component.scss'],
    standalone: false,
})
export class CommandsPropertiesComponent {
    @Input() public commands: ICommand[];
    @Input() public isCommandExecuting: { [name: string]: boolean };
    @Input() public commandError: { [name: string]: string };
    @Input() public isSelectedAssetDisabled: boolean;
    @Output() public emitExecuteCommand = new EventEmitter<CommandSelectedEvent>();

    public executeCommand(command: ICommand) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const commandPara = {} as any;
        commandPara[command.request.schema.fields[0].name] = command.request.schema.fields[0].schema.enumValues[0].enumValue;

        const commandValue: CommandSelectedEvent = { name: command.name, parameters: commandPara };
        this.emitExecuteCommand.emit(commandValue);
    }

    public executeCommandPass(name: string, parameters: { [key: string]: string }) {
        const commandValue: CommandSelectedEvent = { name, parameters };
        this.emitExecuteCommand.emit(commandValue);
    }
}
